import _ from 'lodash';
import React, { PureComponent } from 'react';
import debug from 'debug';

import { getCurrentMediaQueryKey, getMediaQueryBoundaries } from 'common/utils/story-media-query';

import { Props, State } from './types';
import { Context } from './Context';

const log = debug('client:components:ResponsiveProvider');

class ResponsiveProvider extends PureComponent<Props, State> {
	constructor(props: Props) {
		super(props);

		const { mediaQuery } = props;
		const currentMediaQuery = getCurrentMediaQueryKey({ mediaQuery });
		log(`Set MediaQuery (initial) — %c${currentMediaQuery}`, 'font-weight: bold');

		this.state = {
			currentMediaQueryKey: currentMediaQuery,
			boundaries: getMediaQueryBoundaries({ currentMediaQuery, mediaQuery }),
		};
	}

	componentDidMount() {
		this.setPlatformAttr();
		window.addEventListener('resize', _.debounce(this.onWindowResize, 300));
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onWindowResize);
	}

	setPlatformAttr() {
		document.body.setAttribute('data-platform', this.state.currentMediaQueryKey);
	}

	onWindowResize = () => {
		const { currentMediaQueryKey } = this.state;
		const nextMediaQueryKey = getCurrentMediaQueryKey({ mediaQuery: this.props.mediaQuery });

		if (nextMediaQueryKey !== currentMediaQueryKey) {
			log(`Set MediaQuery (update) — %c${nextMediaQueryKey}`, 'font-weight: bold');
			this.setState(
				{
					currentMediaQueryKey: nextMediaQueryKey,
					boundaries: getMediaQueryBoundaries({
						currentMediaQuery: nextMediaQueryKey,
						mediaQuery: this.props.mediaQuery,
					}),
				},
				() => {
					this.setPlatformAttr();
				}
			);
		}
	};

	render() {
		const { Provider } = Context;
		const { boundaries, currentMediaQueryKey: currentMediaQuery } = this.state;

		return (
			<Provider value={{ currentMediaQuery, boundaries, mediaQuery: this.props.mediaQuery }}>
				{this.props.children}
			</Provider>
		);
	}
}

export default ResponsiveProvider;
